import React from 'react';
import Title from '../title';
import View from './view';
import Viewmaster from './viewmaster';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Permission from '../../functions/permission';
class Stockaudit extends React.Component {

  state = {
    search: '',
    allow: '0', menuPermission: []
  }

  componentDidMount() {
    this.menuControl();
    this.getUrl();
  }

  getUrl() {
    let url = window.location.href;
    url = url.split('/')[5];
    if (!url) {
      this.setState({ open: 'master' })
    }
    else {
      this.setState({ open: 'parts' })
    }
  }

  menuControl() {
    let menuPermission = Permission('stock-audit', this.props.menus);
    this.setState({ menuPermission })
  }

  render() {
    return (
      <div>
      <Title title={'Stock Audit'} openDrawer={this.props.openDrawer}/>
      { this.state.menuPermission.view ?
        (
          <div>
            <Viewmaster stockauditexport={this.state.stockauditexport} menuPermission={this.state.menuPermission}
              stockauditedit={this.state.stockauditedit} menus={this.props.menus} />
          </div>
        ):
        (
          <div>
            <center>You are not allow to access this menu!!!</center>
          </div>
        )
      }
    </div>
    );
  }
}

export default Stockaudit;
